const state = {
    showOverlay: 0,//stores the selected client(used in form modal)
    showObservationModal: false,
};

const getters = {
    getShowOverlay(state){
        return state.showOverlay;
    },
    getShowObservationModal(state){
        return state.showObservationModal;
    },
};

const mutations = {
    setShowOverlay(state, payload){
        state.showOverlay = payload;
    },
    setShowObservationModal(state, payload){
        state.showObservationModal = payload;
    },
};

const actions = {
    setShowOverlay({commit}, payload){
        commit('setShowOverlay', payload);
    },
    setShowObservationModal({commit}, payload){
        commit('setShowObservationModal', payload);
    },
};

export default {
    state,
    getters,
    mutations,
    actions
};

